module.exports = __webpack_public_path__ + "img/SES_140250002.5881acc1.jpg";